import router from "../index";
import { isEmpty } from "@/utils/Common";
import store from "@/stores";

router.beforeEach(async (to, from, next) => {
  const matched = to.matched.some((r) => r.meta.auth === true);
  if (!matched) {
    next();
    return;
  }
  try {
    // 获取用户数据
    if (isEmpty(store.getters["user/user"])) {
      await store.dispatch("user/getUser");
    }
    // 如果获取用户失败，重新登录
    if (isEmpty(store.getters["user/user"])) {
      next("/login");
      return;
    }
    // 获取接口数据
    if (isEmpty(store.getters["enums/enums"])) {
      await store.dispatch("enums/getEnums");
    }
    // 获取运行任务
    await store.dispatch("synctask/getDataSyncList");
    next();
  } catch (error) {
    console.info(error);
    next("/error");
  }
});
